module.exports = __webpack_public_path__ + "img/blue_125.08267d14.png";